import { Checkbox, FormGroup, Input, Text } from '@agro-club/agroclub-shared'
import { useAnalyticsClickHandler } from 'analytics/hooks'
import { FormikProps } from 'formik'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FormSelectButton } from 'views/components/FormSelectButtons/FormSelectButtons'
import { HrWithHeader } from 'views/components/Hr/Hr'
import { ShortFormControl } from 'views/styled/common'
import env from '../../../../../env'
import { AddCarrierModal } from '../../CarriersKR/AddCarrierModal/AddCarrierModal'
import { DraftTripsInitial } from '../../LogisticRequests/RequestsBoard/OpenRequestsBoardColumns/DraftTrips/types'
import { MarginWrapper } from './styled'
import FormSelectShared from 'views/components/FormSelectShared'
import { endpoints } from 'modules/endpoints'
import { Carrier, DealType } from 'modules/domain/logisticsKR/types'
import { CarrierOption } from './CarrierOption'
import { CarrierRole } from '../../types'

interface Props {
  formik: FormikProps<DraftTripsInitial>
  controlsDisable: Record<string, boolean> | undefined
}

export const AgentControls: FC<Props> = ({ formik, controlsDisable }) => {
  const { t } = useTranslation('logisticBids')
  const [addAgentModal, setAddAgentModal] = useState(false)
  const currency = env.REACT_APP_CURRENCY_SYMBOL
  const handleClick = useAnalyticsClickHandler('add')
  const [selectedAgent, setSelectedAgent] = useState<Carrier | null>(null)

  return (
    <>
      <HrWithHeader text={t('form.block_titles.mediator_info')} />
      <div>
        <FormSelectShared
          OptionComponent={CarrierOption}
          endpoint={endpoints.LogisticsKR.carriers()}
          placeholder={''}
          getLabel={(dto) => dto.name}
          label={t('form.labels.mediator')}
          fieldName="agent"
          disabled={controlsDisable?.agent}
          formik={formik}
          searchField="search"
          onSelectedOptionLoaded={(e) => setSelectedAgent(e.dto)}
        >
          <FormSelectButton
            action={handleClick(() => setAddAgentModal(true))}
            eventId="addAgent"
            disabled={controlsDisable?.agent}
          />
        </FormSelectShared>
        <MarginWrapper>
          <Checkbox
            isChecked={formik.values.has_agent_vat}
            onChange={(_value, isChecked) => formik.setFieldValue('has_agent_vat', isChecked)}
            label={t('form.labels.vat')}
          />
          <Text color="secondary">{formik.values.agent && selectedAgent?.inn ? `ИНН: ${selectedAgent.inn}` : ''}</Text>
        </MarginWrapper>
      </div>
      {addAgentModal && (
        <AddCarrierModal
          title={t('form.titles.add_agent')}
          onClose={() => setAddAgentModal(false)}
          initialValues={{
            carrier_role: [
              formik.values.deal_type === DealType.forwarding_company ? CarrierRole.forwarder : CarrierRole.agent,
            ],
          }}
          onSuccess={(val: Carrier) => {
            formik.setFieldValue('agent', val.id)
          }}
        />
      )}

      <ShortFormControl>
        <FormGroup label={t('form.labels.agent_commission', { currency })}>
          <Input {...formik.getFieldProps('agent_commission')} />
        </FormGroup>
      </ShortFormControl>
    </>
  )
}
